/** Shared validation patterns (string patterns for HTML inputs and RegExp for tests). */
export const patterns = {
    email: '[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$',
    // chromium's email test
    emailRegex:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    phone: '\\d{3}[\\-]\\d{3}[\\-]\\d{4}',
    htmlPhone: '[0-9]{3}-[0-9]{3}-[0-9]{4}',
    phoneRegex: /[0-9]{3}-[0-9]{3}-[0-9]{4}/g,
};

/** Test whether a string matches the `nnn-nnn-nnnn` phone pattern. */
export const phone = (value: string): boolean => patterns.phoneRegex.test(value);

/** Test whether a string is a valid email address. */
export const email = (str: string): boolean => patterns.emailRegex.test(str);

/**
 * Return the postal-code validation pattern for a country id (1 = US, 2 = Canada).
 * Falls back to the US pattern for unknown/absent country ids.
 */
export const getZipPattern = (countryId?: number): string => {
    const zipPatterns: Record<number, string> = {
        1: '\\d{5}(-\\d{4})?', // US ZIP Code format
        2: '[A-Za-z]\\d[A-Za-z]\\s?\\d[A-Za-z]\\d', // Canadian Postal Code format
    };

    const DEFAULT_COUNTRY = 1;

    return zipPatterns[countryId || DEFAULT_COUNTRY] || zipPatterns[DEFAULT_COUNTRY];
};
